
import { defineComponent, onMounted } from "vue";
import CustomersList from "../components/CustomersList.vue";
import { setPageHeader } from "@/core/helpers/toolbar";
export default defineComponent({
	components: {
		CustomersList,
	},
	setup() {
		onMounted(() => {
			setPageHeader({
				title: "message.CUSTOMERS",
				actionButton: null,
				breadCrumbs: [{ name: "message.HOME", link: "/dashboard" }, { name: "message.CUSTOMERS", link: "#" }, { name: "message.CUSTOMERS" }],
			});
		});
	},
});
